import { client } from '@iris/content';
import { useQuery } from '@tanstack/react-query';
import groq from 'groq';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from 'src/constants';
import { getStage } from 'src/modules/general-helpers';

import { AppNotification } from './types';

const importantNotification = groq`*[
  _type == 'notification' &&
  __i18n_lang == $lang &&
  messageType == 'important' &&
  stage == $stage
]|order(coalesce(__i18n_base->orderRank, orderRank)) {
  _id,
  updatedAt,
  "baseUpdatedAt": __i18n_base->updatedAt,
  title,
  "slug": slug.current,
  shortInfo,
  messageType,
  description,
  added,
  startTime,
  endTime,
  countries,
  roles
}
`;

export const useImportantNotification = () => {
  const { i18n } = useTranslation();
  const stage = getStage();

  return useQuery<AppNotification[]>(
    [QueryKeys.notifications, 'important', i18n.language],
    () => client.fetch<AppNotification[]>(importantNotification, { lang: i18n.language, stage }),
    {
      staleTime: 10000,
      suspense: true,
      useErrorBoundary: false,
      refetchInterval: 30 * 60 * 1000, // 30 Minutes
    },
  );
};

const notImportantNotification = groq`*[
  _type == 'notification' &&
  __i18n_lang == $lang &&
  messageType != 'important' &&
  stage == $stage
]|order(coalesce(__i18n_base->orderRank, orderRank)) {
  _id,
  updatedAt,
  "baseUpdatedAt": __i18n_base->updatedAt,
  title,
  "slug": slug.current,
  shortInfo,
  messageType,
  description,
  added,
  startTime,
  endTime,
  countries,
  roles
}`;

export const useNotImportantNotification = () => {
  const { i18n } = useTranslation();
  const stage = getStage();

  return useQuery<AppNotification[]>(
    [QueryKeys.notifications, 'not-important', i18n.language],
    () => client.fetch<AppNotification[]>(notImportantNotification, { lang: i18n.language, stage }),
    {
      staleTime: 10000,
      suspense: true,
      useErrorBoundary: false,
      refetchInterval: 3 * 60 * 60 * 1000, // 3 hours
    },
  );
};
